import React, { useContext } from 'react';

import Button from '@material-ui/core/Button';
import ButtonGroup from '@material-ui/core/ButtonGroup';
import ZoomInRoundedIcon from '@material-ui/icons/ZoomInRounded';
import ZoomOutRoundedIcon from '@material-ui/icons/ZoomOutRounded';

import { colors } from 'theme/palette';
import { trackMixpanelEvent } from 'utils/integrations/mixpanel';
import {
  MixpanelAction,
  MixpanelObject
} from 'utils/integrations/mixpanel/constants';

import Typography from 'components/Typography';
import UserContext from 'components/UserContext';

import styles from './styles.module.scss';

const ZoomControlls = ({ zoom }) => {
  const user = useContext(UserContext);

  return (
    <ButtonGroup
      variant="contained"
      disableElevation
      className={styles.zoomControlls}
    >
      <Button
        className={styles.zoomOutIcon}
        onClick={(e) => {
          zoom.zoomOut(e);
          trackMixpanelEvent(
            user.id,
            `${MixpanelObject.BUTTON} ${MixpanelAction.CLICK}`,
            {
              feature: 'assignments',
              view: 'feedback',
              button: 'zoom',
              action: 'out'
            }
          );
        }}
        disabled={zoom.scale <= 1}
      >
        <ZoomOutRoundedIcon style={{ color: colors.blue3 }} fontSize="large" />
      </Button>
      <Button
        disableElevation
        disabled={true}
        variant="text"
        className={styles.percentage}
      >
        <Typography variant="H-TEXT-3" color={colors.blue3}>
          {Math.round((zoom.scale - 1) * 10 + 100)}%
        </Typography>
      </Button>
      <Button
        className={styles.zoomInIcon}
        onClick={(e) => {
          zoom.zoomIn(e);
          trackMixpanelEvent(
            user.id,
            `${MixpanelObject.BUTTON} ${MixpanelAction.CLICK}`,
            {
              feature: 'assignments',
              view: 'feedback',
              button: 'zoom',
              action: 'in'
            }
          );
        }}
        disabled={zoom.scale >= 11}
      >
        <ZoomInRoundedIcon style={{ color: colors.blue3 }} fontSize="large" />
      </Button>
    </ButtonGroup>
  );
};
export default ZoomControlls;
